var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"auth-app"}},[_c('pc-singleton-modals',{attrs:{"id":"singleton-auth-modals"}}),_c('pc-singleton-overlay',{attrs:{"id":"singleton-auth-overlay"}}),_c('pc-singleton-snackbar',{attrs:{"id":"singleton-auth-snackbar"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }